module.exports = __webpack_public_path__ + "img/the mansions two beauties.69e431d7.png";